import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const KEY = 'voip2_consent';
const ALL = ['ad_storage', 'ad_user_data', 'ad_personalization', 'analytics_storage'];

const read = () => { try { return localStorage.getItem(KEY); } catch (e) { return null; } };

// Asks once before Google Tag Manager may set analytics or advertising cookies (Consent Mode is "denied" until then;
// see public/index.html). Only on the website build, where GTM is loaded.
const CookieConsent = () => {
  const [open, setOpen] = useState(false);
  useEffect(() => { if (typeof window.gtag === 'function' && !read()) setOpen(true); }, []);
  if (!open) return null;

  const choose = (value) => {
    try { localStorage.setItem(KEY, value); } catch (e) { /* private mode: ask again next visit */ }
    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', Object.fromEntries(ALL.map((k) => [k, value])));
      window.dataLayer.push({ event: value === 'granted' ? 'consent_granted' : 'consent_denied' });
    }
    setOpen(false);
  };

  return (
    <div role="dialog" aria-live="polite" aria-label="Cookie choices"
      className="fixed inset-x-0 bottom-0 z-[60] p-4 sm:p-6">
      <div className="mx-auto flex max-w-3xl flex-col gap-4 rounded-2xl border border-white/10 bg-[#0a1f2e] p-5 text-white shadow-2xl sm:flex-row sm:items-center">
        <p className="flex-1 text-sm text-white/80">
          We use cookies to understand how our site is used and to improve it. You can accept or reject non-essential
          cookies. <Link to="/cookie-policy" className="underline hover:text-[#c8ff00]">Cookie Policy</Link>
        </p>
        <div className="flex gap-2">
          <button type="button" onClick={() => choose('denied')}
            className="rounded-lg border border-white/30 px-4 py-2 text-sm font-semibold hover:bg-white/10">Reject</button>
          <button type="button" onClick={() => choose('granted')}
            className="rounded-lg bg-[#c8ff00] px-4 py-2 text-sm font-semibold text-[#0a1f2e] hover:opacity-90">Accept</button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
